/* @flow */
import React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

export default function IconCancel(props) {
  return (
    <SvgIcon viewBox="0 0 62.72 62.69" {...props}>
      <g>
        <path d="M433.55,307.73l-10.28-10.28,10.09-10.09a1.51,1.51,0,0,0,0-2.12,1.49,1.49,0,0,0-2.12,0l-10.09,10.09-10-10a1.51,1.51,0,0,0-2.12,0,1.49,1.49,0,0,0,0,2.12l10,10-10.19,10.18a1.51,1.51,0,0,0,0,2.12,1.48,1.48,0,0,0,1.06.44,1.45,1.45,0,0,0,1.06-.44l10.19-10.18,10.28,10.28a1.49,1.49,0,0,0,1.06.44,1.53,1.53,0,0,0,1.06-.44A1.51,1.51,0,0,0,433.55,307.73Z" transform="translate(-389.88 -266.23)" />
      </g>
    </SvgIcon>
  );
}
